// extracted by mini-css-extract-plugin
module.exports = {"searchbar":"Searchbar_searchbar__2_vbX"};